module.exports = __webpack_public_path__ + "img/Logomark-Transparent White.98140510.png";